import React from 'react'
import {
  ensurePartnerIdAndCampaign,
  replaceWildcards,
} from '../../lib/helper/helper'
import { IdealImage } from './IdealImage'
import Link from '../overwrites/Link'

type Props = {
  widget: TravelPlanWidget
  wildcards?: Wildcards
}

export function TravelPlanWidget({ widget, wildcards = {} }: Props) {
  if (!widget) return null
  const { text_above, title, sub_title, image, global_link } = widget

  if (!global_link) return null

  const isExternal = (href: string) =>
    !href.startsWith('/') && !href.startsWith('#')
  const target = isExternal(global_link) ? '_blank' : undefined
  const rel = isExternal(global_link) ? 'noopener noreferrer' : undefined

  return (
    <Link
      href={ensurePartnerIdAndCampaign(global_link)}
      passHref
      target={target}
      rel={rel}
      className="mx-3 xs:mx-0 my-10 rounded-lg overflow-hidden gyg-widget-copy flex flex-col md:flex-row bg-white group md:h-52"
      style={{ padding: '0' }}
    >
      <div className="md:w-1/3 w-full md:h-auto overflow-hidden h-48">
        <div className="w-full h-full group-hover:scale-110 transition-transform duration-300 ease-in-out">
          <IdealImage image={image} alt={title} />
        </div>
      </div>
      <div className="md:w-2/3 md:mx-12 mx-2 flex flex-col justify-center items-center p-4 text-center">
        <p className="text-lg mb-2 uppercase font-medium text-neutral">
          {replaceWildcards(text_above, wildcards)}
        </p>
        <h2 className="text-2xl font-medium mb-2 group-hover:text-primary">
          {replaceWildcards(title, wildcards)}
        </h2>
        <div className="text-lg mb-2">
          {replaceWildcards(sub_title, wildcards)}
        </div>
      </div>
    </Link>
  )
}
